import initials from 'initials'

import type { StorageResource } from '@campai/lib-common/entities'

import { Avatar, AvatarFallback, AvatarImage, type AvatarSizeType } from '@/components/new/ui/avatar'

export const OrganizationAvatar = ({
    name,
    avatar,
    size = 'default',
    className,
}: {
    name: string
    avatar?: StorageResource | string | null
    size?: AvatarSizeType
    className?: string
}) => (
    <Avatar square size={size} className={className}>
        <AvatarImage
            src={typeof avatar === 'string' ? avatar : avatar?.resource}
            alt={name}
            className="!rounded-[inherit]"
        />
        <AvatarFallback className="!rounded-[inherit]">
            {initials(name).slice(0, 2).toUpperCase() || '?'}
        </AvatarFallback>
    </Avatar>
)
